import { Rooms } from '@search/filter-enums/enums/Rooms';
import { RoomsEnum } from '../__generated__/SearchOffersQuery.graphql';

export function roomTypeFilterCompat(roomType: RoomsEnum | null) {
    switch (roomType) {
        case 'OPEN_PLAN': return Rooms.OPEN_PLAN;
        case 'ROOM_1': return Rooms.ROOM_1;
        case 'ROOM_2': return Rooms.ROOM_2;
        case 'ROOM_3': return Rooms.ROOM_3;
        case 'ROOM_4': return Rooms.ROOM_4;
        case 'ROOM_4_AND_MORE': return Rooms.ROOM_4;
        case 'ROOM_5_AND_MORE': return Rooms.ROOM_5_AND_MORE;
        case 'STUDIO': return Rooms.STUDIO;
        default: return undefined;
    }
}
